import React, { useState, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMapMarkerAlt,
  faSun,
  faMoon,
} from "@fortawesome/free-solid-svg-icons";
import CheckPass from "./CheckPass";
import Login from "./Login";
import UserStatus from "../context/UserStatus";
import GetKala from "./GetKala";
import { ProductProvider } from "../context/ProductContext";
import useTheme from "./useTheme";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Infographic from "./Infographic";
import VitrinMessage from "./VitrinMessage";
import Profile from "./Profile";
import { LoginContext } from "../context/LoginContext.js";
import Kala from "./Kala";

const Vitrin = (props) => {
  const [data, setData] = useState({ result: true });

  const [backgrond, setBackGround] = useState("");

  const [theme, switchTheme] = useTheme();

  const [pageKala, setPageKala] = useState(0);

  const pass = useContext(UserStatus);

  const loginContext = useContext(LoginContext);

  useEffect(() => {
    const formData = new FormData();
    formData.append("get_background", 1);
    formData.append("vitrinCode", props.id);
    const myRequest = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(myRequest)
      .then((res) => res.json())
      .then((data) => {
        setBackGround(data.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    const formData = new FormData();
    formData.append("check_vitrin", 1);
    formData.append("vitrin_id", props.id);
    formData.append("test", props.id);
    const myRequest = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(myRequest)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      })
      .catch((e) => console.log(e));
  }, [props.id]);

  if (data.result === true) {
    if (data.data !== undefined) {
      const tel =
        data.data.tel !== "" ? (
          <div className="info">
            <FontAwesomeIcon icon={faPhone} />
            <a href={"tel:" + data.data.tel}>{data.data.tel}</a>
          </div>
        ) : (
          ""
        );

      const img =
        data.data.logo !== "" ? (
          <img
            src={data.data.logo}
            className="image rounded-circle"
            alt={data.data.name}
          />
        ) : (
          ""
        );

      const address =
        data.data.address !== "" ? (
          <div className="info">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            {data.data.address}
          </div>
        ) : (
          ""
        );

      const telegram =
        data.data.telegram_id !== "" ? (
          <a className="info btn-link" href={data.data.telegram_id}>
            <img
              alt="telegram"
              className="brand rounded-circle"
              src={data.data.telegram_image}
            />
          </a>
        ) : (
          ""
        );

      const instagram =
        data.data.telegam_id !== "" ? (
          <a className="info btn-link" href={data.data.instagram_id}>
            <img
              alt="instagram"
              className="brand rounded-circle"
              src={data.data.instagram_image}
            />
          </a>
        ) : (
          ""
        );

      const website =
        data.data.telegam_id !== "" ? (
          <a className="info btn-link" href={data.data.website_id}>
            <img
              alt="website"
              className="brand rounded-circle"
              src={data.data.website_image}
            />
          </a>
        ) : (
          ""
        );

      // if (!data.data.is_show_pass) {
      //   pass.login();
      // }
      // if (!pass.status) {
      //   return (
      //     <div>
      //       <CheckPass id={props.id} />
      //     </div>
      //   );
      // }

      if (props.kala > 0) {
        return (
          <>
            <Login id={props.id} />
            <Kala vitrinCode={props.id} kala={props.kala} />
          </>
        );
      } else {
        return (
          <div
            style={{
              backgroundImage: "url(" + backgrond + ")",
            }}
            className={
              theme === "light" || backgrond.trim === ""
                ? "back"
                : "back main-bg"
            }
          >
            {/* <div>
            <nav className="rtl navbar navbar-light bg-dark">
              <div className="form-inline">
                <button className="nav-item btn btn-dark">خدمات</button>
                <button className="nav-item btn btn-dark">گزارش</button>
              </div>
            </nav>
          </div> */}
            <Login id={props.id} />
            <div className="container">
              <div
                className={
                  theme === "light"
                    ? "card shadow rounded card-border rtl mt-4"
                    : "card shadow rounded card-border rtl mt-4 bg-dark text-white"
                }
              >
                <div className="card-header rtl">
                  {img}
                  <div className="h4 name">{data.data.name}</div>
                </div>
                <div className="card-body rtl">
                  {/* {tel} */}
                  {address}
                </div>
                <div className="card-footer inlined">
                  <div>
                    {telegram}
                    {instagram}
                    {website}
                  </div>

                  <div>
                    <Profile vitrinCode={props.id} type={"icon"} />
                    <BootstrapSwitchButton
                      checked={theme === "light" ? false : true}
                      onlabel={<FontAwesomeIcon icon={faMoon} />}
                      offlabel={<FontAwesomeIcon icon={faSun} />}
                      onstyle="light"
                      offstyle="dark"
                      size="sm"
                      onChange={switchTheme}
                    />
                  </div>
                </div>
              </div>

              <VitrinMessage vitrinCode={props.id} type={"marquee"} />

              <div>
                <Infographic vitrinCode={props.id} />
                <GetKala
                  id={props.id}
                  isVisitor={0}
                  kala={props.kala}
                  isReturn={props.isReturn}
                />
              </div>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className="row justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="card">
        <div className="m-5">{"ویترین یافت نشد"}</div>
      </div>
    );
  }
};
export default Vitrin;
